module.exports = __webpack_public_path__ + "static/img/AL@3x.9fa8ca91.jpg";